import { z } from 'zod/v3';

import { frequentlyOrderProductSchema } from './frequently-order';

/**
 * 쿠폰 적용 가능 상품 (MarketSelectProductResponseV2)
 * frequently-order 의 상품 모델과 동일 DTO 이므로 재사용한다.
 */
export const buyerCouponProductItemSchema = frequentlyOrderProductSchema;
export type BuyerCouponProductItem = z.infer<
  typeof buyerCouponProductItemSchema
>;

/** 커서 페이지네이션된 쿠폰 상품 목록 (CursorPagedResponseMarketSelectProductResponseV2) */
export const cursorPagedBuyerCouponProductsSchema = z.object({
  /** 상품 목록 */
  content: z.array(buyerCouponProductItemSchema),
  /** 다음 페이지 여부 */
  hasNextPage: z.boolean(),
  /** 마지막 항목 ID (다음 페이지 요청 시 사용) */
  lastId: z.number().optional(),
  /** 다음 페이지 요청용 커서 */
  searchAfter: z.array(z.string()).optional(),
  /** 정렬 타입 */
  sortType: z.string().optional(),
});
export type CursorPagedBuyerCouponProducts = z.infer<
  typeof cursorPagedBuyerCouponProductsSchema
>;

/** 쿠폰 상품 응답 (BuyerCouponProductResponse) */
export const buyerCouponProductsSchema = z.object({
  /** 쿠폰 ID */
  couponId: z.number().optional(),
  /** 상품 목록 (커서 페이지네이션) */
  products: cursorPagedBuyerCouponProductsSchema,
  /** 전체 상품 수 */
  totalCount: z.number(),
});
export type BuyerCouponProducts = z.infer<typeof buyerCouponProductsSchema>;
